export const csvTableFormat = [
  {
    row: 'Nome',
    required: true,
    additional_information: '',
    values: '',
    format: 'Texto Livre',
  },

  {
    row: 'Telefone',
    required: true,
    additional_information: 'DD + Numero',
    values: '',
    format: 'Somente número',
  },
  {
    row: 'Telefone 2',
    required: false,
    additional_information: 'DD + Numero',
    values: '',
    format: 'Somente número',
  },
  {
    row: 'Aniversário',
    required: false,
    additional_information: '',
    values: 'Ex: 01/12/1998',
    format: 'dd/mm/aaaa',
  },
  {
    row: 'CEP',
    required: false,
    additional_information:
      'O endereço será buscado automaticamente com base no CEP (caso fornecido).',
    values: '',
    format: 'Somente número',
  },
  {
    row: 'Número',
    required: false,
    additional_information: '',
    values: '',
    format: 'Somente número',
  },

  {
    row: 'UF',
    required: false,
    additional_information: 'Ex: MG',
    values: '',
    format: 'Sigla',
  },
  {
    row: 'Documento',
    required: false,
    additional_information: 'CPF/CNPJ (Ex: 27788434000)',
    values: '',
    format: 'Somente número',
  },
]
